import { useRef, useState } from "react"
import { Button, Menu, Portal, Stack, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { Repeat } from "lib/@components/repeat"
import { Bound } from "lib/@components/binding/Bound"
import { CriticalityMenuItem } from "./criticality-menu-item"
import { CRITICALITY_OPTIONS } from "./criticality-config"

export function CriticalityDropdown({ value, onChange }) {
    const [anchor, setAnchor] = useState(null)
    const ref = useRef()
    const current = CRITICALITY_OPTIONS.find((o) => o.value === value) ?? CRITICALITY_OPTIONS[0]

    return (
        <>
            <Button
                ref={ref}
                onClick={open}
                size="small"
                variant="outlined"
                sx={{ textTransform: "none", minWidth: 120 }}
            >
                <Stack direction="row" spacing={0.75} alignItems="center">
                    <Iconify icon={current.icon} sx={{ fontSize: 14, color: current.color }} />
                    <Typography variant="body2">{current.label}</Typography>
                    <Iconify icon="mdi:arrow-down-drop" sx={{ fontSize: 20 }} />
                </Stack>
            </Button>
            <Portal>
                <Menu sx={{ zIndex: 3000 }} open={Boolean(anchor)} anchorEl={anchor} onClose={close}>
                    <Bound currentValue={value} onSelect={handleSelect}>
                        <Repeat list={CRITICALITY_OPTIONS} item={<CriticalityMenuItem />} />
                    </Bound>
                </Menu>
            </Portal>
        </>
    )

    function open() {
        setAnchor(ref.current)
    }

    function close() {
        setAnchor(null)
    }

    function handleSelect(newValue) {
        onChange(newValue)
        close()
    }
}
